import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import * as _ from 'lodash';

import Modal from '../../../common/Modal';
import Button from '../../../common/Button';
import Create from '../../../memos/Create';
import List from './List';
import i18n from '../../../core/i18n';

class Memos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shareMemoModalOpen: this.props.triggerCreate,
    };
  }

  handleShareMemoModalOpen = () => {
    this.setState({ shareMemoModalOpen: true });
  };
  handleShareMemoModalClose = () => {
    this.setState({ shareMemoModalOpen: false });
  };

  render() {
    const { project, t, memos, titleShareBtn } = this.props;
    const { shareMemoModalOpen } = this.state;

    return (
      <React.Fragment>
        <div className="u-margin-bottom-micro u-display-flex u-flex-wrap u-justify-content-between u-align-items-center">
          <h4 className="u-margin-bottom-micro">{t('project.memo.title')}</h4>
          {!_.isEmpty(memos) && (
            <Button styleType="outline" onClick={this.handleShareMemoModalOpen}>
              {titleShareBtn || i18n.t('project.memo.btn')}
            </Button>
          )}
        </div>
        <div className="o-layout o-layout--large u-margin-bottom-huge">
          <List
            handleOnShareClick={this.handleShareMemoModalOpen}
            project={project}
          />
        </div>
        <Modal
          isOpen={shareMemoModalOpen}
          onRequestClose={this.handleShareMemoModalClose}
          title={t('project.memo.modalTitle')}
        >
          <Create
            project={project}
            onSuccess={this.handleShareMemoModalClose}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ projectMemos }) => ({
  memos: projectMemos.data,
});

export default connect(mapStateToProps)(translate()(Memos));



// WEBPACK FOOTER //
// ./src/projects/details/memos/index.js